import { ReceivingCharts } from "../Receiving/receivingDashboard/ReceivingCharts";
import Button from "../../components/shared/buttons/button";
import "./dashboard.css";
import { useNavigate } from "react-router";
import RipeningCharts from "../ripening/dashboard/RipeningCharts";
import ProcessingCharts from "../processing/dashboard/ProcessingCharts";
import PackingCharts from "../packing/overview/PackingCharts";
import BrokerageDashboardChart from "../brokerage/overview/BrokerageDashboardChart";
import useTranslator from "../../hooks/useTranslator";
import { useSelector } from 'react-redux';
import { capitalizeWords } from "../../helpers/Utils";
import usePermissions from "../../hooks/usePermissions";
import { jwtDecode } from "../../helpers/AccessControlUtils";

const PRIVILEGED_ROLES = ["admin", "super_admin", "general_manager"];



const Dashboard = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const userRole = useSelector(state => state.global.userRole);
  const { checkPermission } = usePermissions();
  const viewMore = _t("view_more", "View More");
  const decodedToken = jwtDecode();
  const roleSlug = decodedToken?.role; 
  

  const isPrivileged = PRIVILEGED_ROLES.includes(roleSlug);


  const canSeeReceiving  = isPrivileged || roleSlug === "receiving_manager"         || checkPermission("receiving.dashboard", "view");
  const canSeeRipening   = isPrivileged || roleSlug === "ripening_selection_manager" || checkPermission("ripening.dashboard", "view");
  const canSeeProcessing = isPrivileged || roleSlug === "processing_cooking_manager" || checkPermission("processing.dashboard", "view");
  const canSeePacking    = isPrivileged || roleSlug === "packing_manager"            || checkPermission("packing.dashboard", "view");
  const canSeeBrokerage  = isPrivileged || roleSlug === "brokerage_manager"          || checkPermission("brokerage.dashboard", "view");
  

  return (
    <>
      {userRole && (
        <h1 className="dashboard_heading">
          {_t("welcome_text", "Welcome, :role_name", { role_name: _t(userRole ,capitalizeWords(userRole)) })}
        </h1>
      )}

      {canSeeReceiving && (
        <div className="dash_card">
          <div className="d-flex justify-content-between align-items-center dash_header">
            <h3 className="mb-0">{_t("receiving_overview", "Receiving Overview")}</h3>
            <Button size="xs" label={viewMore} className="borderRedBtn" onClick={() => navigate("/receiving-dashboard")} />
          </div>
          <ReceivingCharts />
        </div>
      )}

      {canSeeRipening && (
        <div className="dash_card mb-3">
          <div className="d-flex justify-content-between align-items-center dash_header">
            <h3 className="mb-0">{_t("ripening_overview", "Ripening Overview")}</h3>
            <Button size="xs" label={viewMore} className="borderRedBtn" onClick={() => navigate("/ripening-dashboard")} />
          </div>
          <RipeningCharts />
        </div>
      )}

      {canSeeProcessing && (
        <div className="dash_card">
          <div className="d-flex justify-content-between align-items-center dash_header">
            <h3 className="mb-0">{_t("processing_overview", "Processing Overview")}</h3>
            <Button size="xs" label={viewMore} className="borderRedBtn" onClick={() => navigate("/processing-dashboard")} />
          </div>
          <ProcessingCharts />
        </div>
      )}

      {canSeePacking && (
        <div className="dash_card">
          <div className="d-flex justify-content-between align-items-center dash_header">
            <h3 className="mb-0">{_t("packing_overview", "Packing Overview")}</h3>
            <Button size="xs" label={viewMore} className="borderRedBtn" onClick={() => navigate("/packing-dashboard")} />
          </div>
          <PackingCharts />
        </div>
      )}

      {canSeeBrokerage && (
        <div className="dash_card">
          <div className="d-flex justify-content-between align-items-center dash_header">
            <h3 className="mb-0">{_t("brokerage_overview", "Brokerage Overview")}</h3>
            <Button size="xs" label={viewMore} className="borderRedBtn" onClick={() => navigate("/brokerage-dashboard")} />
          </div>
          <BrokerageDashboardChart />
        </div>
      )}
    </>
  );
};

export default Dashboard;
